import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';

import { SeasonParticipationInfo, badgeImageUrl } from '../../service/player.service';
import { SeasonBadgeComponent } from './seasonBadge.component';

/**
 * "Teilnahmeabzeichen" section: one badge per finished league season the driver
 * has raced in (the API excludes active / planning seasons). A season attended
 * in full earns the golden 100% badge.
 * Each badge exposes a stable, copyable static SVG link (api/badge.php) for use
 * in other applications. Hidden when there are no participations.
 */
@Component({
    selector: 'app-member-badges',
    standalone: true,
    templateUrl: './memberBadges.component.html',
    styleUrls: ['./memberBadges.component.scss'],
    imports: [CommonModule, FormsModule, ButtonModule, SelectButtonModule, TooltipModule, SeasonBadgeComponent],
})
export class MemberBadgesComponent {
    /** Owner of these badges — required to build the copyable static links. */
    @Input() playerId?: number | null;

    /** Per-season participation incl. 100% completion, from the API. */
    @Input() participations: SeasonParticipationInfo[] = [];

    /** Resolution (rendered height in px) used for the copied links. */
    readonly sizeOptions = [
        { label: '256', value: 256 },
        { label: '512', value: 512 },
        { label: '1024', value: 1024 },
    ];
    size = 512;

    /** Season whose link was just copied (drives the transient "Kopiert" state). */
    copiedSeasonId: number | null = null;

    badgeUrl(seasonId: number): string {
        return this.playerId ? badgeImageUrl(this.playerId, seasonId, this.size) : '';
    }

    async copyLink(seasonId: number): Promise<void> {
        const url = this.badgeUrl(seasonId);
        if (!url || !navigator.clipboard) return;
        try {
            await navigator.clipboard.writeText(url);
            this.copiedSeasonId = seasonId;
            setTimeout(() => {
                if (this.copiedSeasonId === seasonId) this.copiedSeasonId = null;
            }, 1600);
        } catch {
            // Clipboard unavailable (e.g. insecure context) — fail silently.
        }
    }
}
